import Vue from 'vue/dist/vue.esm.js';


Vue.component('blog-list', {
  data() {
    return {
      list: 0,
      categories: [],
      activeCategory: null,
    }
  },
  mounted(){
    this.getCategories();
    this.getPosts();
  },
  methods: {
    getCategories(){
      fetch('/wp-json/wp/v2/categories')
      .then(response => response.json())
      .then((data) => {

        data.forEach((el) => {
          let category = {
            name: el.name,
            id: el.id
          }
          this.categories.push(category)
        })
      })
    },
    getPosts(category, index){
      let url = '/wp-json/wp/v2/posts';

      if(category){
        url = `/wp-json/wp/v2/posts?categories=5&categories=${category}`
      }

      this.updateActiveCategory(index)

      fetch(url)
      .then(response => response.json())
      .then((data) => {
        console.log(data)
        this.list = data;
      })
    },
    updateActiveCategory(index){
      this.activeCategory = index ? index : null;
    }
  }
});

new Vue({}).$mount('#blogListingWrapper');
